module.exports = __webpack_public_path__ + "static/img/charles59_Japanese_cute_model_white_background_bright_photoclea_1af5af08-7e18-4bfb-909c-1a0e6f4ed712.519e6b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/charles59_Japanese_cute_model_white_background_bright_photoclea_1af5af08-7e18-4bfb-909c-1a0e6f4ed712.png
// module id = lIKq
// module chunks = 0